"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_71c51772{position:relative;padding:10px 84px;cursor:pointer}.root_71c51772 .ms-Link{font-size:12px}\n" }]);
exports.root = "root_71c51772";
//# sourceMappingURL=GroupShowAll.scss.js.map